module.exports = __webpack_public_path__ + "static/img/13.8c25e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/13.jpg
// module id = lQ96
// module chunks = 1